import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import OuvidoriaService from '../../../../services/ouvidoria-auth';
import { Link, useNavigate, Navigate } from 'react-router-dom';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [situacao, setSituacao] = useState("");
    const [esic, setEsic] = useState("");

    const navigate = useNavigate();

    const voltarPaginaAnterior = () => {
        navigate(-1);
    };

    const busca = async (query) => {
        if (query == "") {
            props.setVazio(true)
        } else {
            var response = await OuvidoriaService.buscar(query)
            if (response.data.length >= 1) {
                props.setRequisicoes(response.data)
                props.setVazio(false)
            } else {
                props.setVazio(true)
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `&nome=${encodeURI(nome)}`;
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (esic !== "false" && esic !== "") prepQuery = prepQuery + `&esic=${esic}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col>
                            <Form.Group className="mb-3" controlId="situacao">
                                <FloatingLabel
                                    label="Esic ou Administra?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Esic ou Administra?"
                                        name="esic"
                                        onChange={e => setEsic(e.target.value)}
                                    >
                                        <option value="E-sic">E-sic</option>
                                        <option value="Administra Cidadão">Administra Cidadão</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="situacao">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="situacao"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Pendente">Pendente</option>
                                        <option value="Recebido pela Prefeitura">Recebido pela Prefeitura</option>
                                        <option value="Encaminhada à Secretaria Responsável">Encaminhada à Secretaria Responsável</option>
                                        <option value="Secretaria Responsável está atuando">Secretaria Responsável está atuando</option>
                                        <option value="Resolvido">Resolvido</option>
                                        <option value="1º Recurso">1º Recurso</option>
                                        <option value="2º Recurso">2º Recurso</option>
                                        <option value="Último Recurso">Último Recurso</option>
                                        <option value="Encerrado">Encerrado</option>
                                        <option value="Indeferido, justificado via mensagem">Indeferido, justificado via mensagem</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Nome">
                                <FloatingLabel
                                    label="Nome Completo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button variant="danger" onClick={voltarPaginaAnterior} type="button">Voltar</Button>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca